import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { Button, Label, TextInput, Checkbox, Alert, Card } from 'flowbite-react';
import { useToast } from '../components/ToastProvider';

export default function CreateApp() {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [form, setForm] = useState({ name: '', slug: '', bot_token: '', import_fixtures: false });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await api.post('/apps', form);
      addToast({ type: 'success', message: 'Приложение создано' });
      navigate('/apps');
    } catch (e) {
      if (/существует|exists/i.test(e.message)) {
        setError('Приложение с таким названием уже существует');
      } else {
        setError(e.message);
      }
    }
  };

  return (
    <div className="grid gap-4">
      <Card>
        <h2 className="text-lg font-semibold">Создать приложение</h2>
        {error && <Alert color="failure" className="mt-2">{error}</Alert>}
        <form onSubmit={submit} className="flex flex-col gap-3 max-w-xl mt-2">
          <div>
            <Label htmlFor="name" value="Название" />
            <TextInput id="name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required />
          </div>
          <div>
            <Label htmlFor="slug" value="Slug" />
            <TextInput id="slug" value={form.slug} onChange={e => setForm({ ...form, slug: e.target.value })} />
          </div>
          <div>
            <Label htmlFor="bot_token" value="Bot token" />
            <TextInput id="bot_token" value={form.bot_token} onChange={e => setForm({ ...form, bot_token: e.target.value })} />
          </div>
          <div className="text-sm text-gray-500">WebApp URL не указывается вручную — он вычисляется на основе фронтенда.</div>
          <div className="flex items-center gap-2">
            <Checkbox id="import_fixtures" checked={form.import_fixtures} onChange={e => setForm({ ...form, import_fixtures: e.target.checked })} />
            <Label htmlFor="import_fixtures" value="Импортировать фикстуры" />
          </div>
          <div className="flex gap-2">
            <Button type="submit">Создать</Button>
            <Button color="light" type="button" onClick={() => navigate('/apps')}>Отмена</Button>
          </div>
        </form>
      </Card>
    </div>
  );
}